<template>
  <SlotBanner
    class="spring-sale-banner"
    start="2024-05-15T08:00:00.000Z"
    finish="2024-06-01T06:59:00.000Z"
    @start="$emit('start')"
    @finish="$emit('finish')"
  >
    <div class="spring-sale-banner__cake">
      <img src="@/assets/images/springSale/cake_banner-2x.png" />
    </div>

    <div class="spring-sale-banner__inner">
      <div class="spring-sale-banner__col spring-sale-banner__col_title">
        <span class="title">ANY.RUN is 8!</span>
        <span class="sub-title">From May 15 to May 31</span>
      </div>
      <div class="spring-sale-banner__col spring-sale-banner__col_description">
        <p class="main-desc">From May 15 to May 31</p>
        <p>Celebrate with us and grab your gift</p>
      </div>
      <div class="spring-sale-banner__col">
        <span class="spring-sale-banner__action-wrap">
          <a
            id="spring-sale-pricing"
            class="spring-sale-banner__action-link"
            href="https://app.any.run/plans"
          >
            Get it now
          </a>
        </span>
      </div>
    </div>

    <div class="spring-sale-banner__gift">
      <img src="@/assets/images/springSale/gift-2x.png" />
    </div>

    <a
      class="spring-sale-banner__global-link"
      href="https://app.any.run/plans"
      id="spring-sale-pricing-global"
      target="_blank"
    >
      See the deals
    </a>
  </SlotBanner>
</template>

<script>
import { defineComponent } from 'vue';

import SlotBanner from './SlotBanner.vue';

export default defineComponent({
  name: 'SpringSaleBanner',
  components: { SlotBanner },
});
</script>

<style lang="scss">
.spring-sale-banner {
  background: linear-gradient(112.5deg, #103554 -17.75%, #1b154d 84.73%);
  overflow: hidden;

  * {
    font-family: 'Montserrat', sans-serif;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 467px;
    background: linear-gradient(
      280.66deg,
      #ff561a 12.37%,
      rgba(112, 31, 3, 0) 91.72%
    );
    pointer-events: none;
    z-index: -2;
  }

  .spring-sale-banner__cake {
    position: absolute;
    left: -74px;
    top: -10px;
    z-index: -1;
    width: 318px;
    height: 211px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .spring-sale-banner__gift {
    position: absolute;
    z-index: -1;
    right: -38px;
    top: -13px;
    width: 278px;
    height: 187px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .spring-sale-banner__close-btn {
    display: block;
    width: 32px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 3;
    background-color: rgba(255, 255, 255, 0);
    border: none;
    outline: none;
    opacity: 0.8;
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 1;
    }

    & .icon {
      width: 18px;
      height: 18px;
      fill: #ffffff;
    }
  }

  .spring-sale-banner__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 915px;
    height: 100%;
    padding: 0 22px;
    box-sizing: content-box;
    margin: 0 auto;
  }

  .spring-sale-banner__col_title {
    .title {
      font-weight: 900;
      font-size: 43px;
      line-height: 43px;
      text-transform: uppercase;
      background-color: rgba(255, 211, 97, 1);
      background-image: linear-gradient(
        95.12deg,
        rgba(255, 93, 41, 1) -3.17%,
        rgba(255, 211, 97, 1) 88.93%
      );
      background-repeat: repeat;

      background-size: 100%;
      background-clip: text;

      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -moz-background-clip: text;
      -moz-text-fill-color: transparent;
    }

    .sub-title {
      display: none;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
    }
  }

  .spring-sale-banner__col_description {
    color: #fff;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;

    p {
      margin: 0;
    }

    .main-desc {
      font-size: 23px;
      line-height: 23px;
      font-weight: 800;
      display: block;
      margin-bottom: 8px;
      text-transform: uppercase;
    }
  }

  .spring-sale-banner__action-wrap {
    display: block;
    padding: 1px;
    background: linear-gradient(94.69deg, #f4739a 3.1%, #fcaa7c 93.85%);
    border-radius: 3px;
    position: relative;
    z-index: 2;
  }

  .spring-sale-banner__action-link {
    width: 173px;
    height: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: #fff;
    background: #fdbc3e;
    background: linear-gradient(95.28deg, #f3551d 1.15%, #fdbc3e 109.28%);
    text-align: center;
    display: block;
    text-decoration: none;

    &:hover,
    &:active {
      background: linear-gradient(94.82deg, #ff4800 -0.12%, #ff9600 97.95%);
      text-decoration: none;
      color: #fff;
    }
  }

  .spring-sale-banner__global-link {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;

    text-indent: -9999px;

    background-color: rgba(255, 255, 255, 0);
    border: none;
    outline: none;
    overflow: hidden;

    cursor: default;
  }
}

@media screen and (max-width: 1366px) {
  .spring-sale-banner {
    .spring-sale-banner__inner {
      max-width: 866px;
    }

    .spring-sale-banner__col_title {
      .title {
        font-size: 40px;
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .spring-sale-banner {
    .spring-sale-banner__cake {
      left: -83px;
      top: 9px;
      width: 254px;
      height: 169px;
    }

    .spring-sale-banner__gift {
      right: -95px;
      top: -10px;
      width: 204px;
      height: 135px;
    }

    .spring-sale-banner__inner {
      max-width: 772px;
    }

    .spring-sale-banner__col_title {
      .title {
        font-size: 32px;
        line-height: 32px;
      }
    }
  }
}

@media screen and (max-width: 979px) {
  .spring-sale-banner {
    .spring-sale-banner__cake {
      left: -74px;
      top: -10px;
      width: 318px;
      height: 211px;
    }

    .spring-sale-banner__inner {
      max-width: 100%;
      justify-content: center;
    }

    .spring-sale-banner__col_title {
      padding-right: 35px;

      .title {
        font-size: 20px;
        line-height: 22px;
        display: block;
        margin-top: 2px;
      }

      .sub-title {
        display: block;
      }
    }

    .spring-sale-banner__col_description {
      display: none;
    }
  }
}

@media screen and (max-width: 730px) {
  .spring-sale-banner {
    &::after {
      display: none;
    }

    .spring-sale-banner__cake {
      left: -101px;
      top: 30px;
      width: 188px;
      height: 125px;
    }

    .spring-sale-banner__gift {
      display: none;
    }
  }
}

@media screen and (max-width: 539px) {
  .spring-sale-banner {
    .spring-sale-banner__col_title {
      padding-right: 10px;

      .title {
        font-size: 18px;
        line-height: 19px;
      }

      .sub-title {
        font-size: 12px;
        line-height: 20px;
      }
    }

    .spring-sale-banner__close-btn {
      right: 0;
      top: 0;
    }
  }
}

@media screen and (max-width: 379px) {
  .spring-sale-banner {
    .spring-sale-banner__inner {
      padding: 0 12px;
    }
  }
}
</style>
